/* Sub Menu Scroll Animation
====================================================*/
$(function(){
	$('a[href^="#"]').click(function(){
		var headerH = $('body.template-index header#SiteHeader').height() - 2;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - headerH;
		$("html, body").animate({scrollTop:position}, 1800, "easeOutExpo");
		return false;
	});
});
/* Sub Menu Current Position
====================================================*/
$(window).on('load', function() {
	var navLink = $('#subMenu li a');
	var contentsArr = new Array();
	for (var i = 0; i < navLink.length; i++) {
		var targetContents = navLink.eq(i).attr('href');
		if(targetContents.charAt(0) == '#') {
			var targetContentsTop = $(targetContents).offset().top;
			var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true);
			contentsArr[i] = [targetContentsTop, targetContentsBottom]
		}
	};
	$(window).on('load resize scroll', function(){
		var adjustH = $(window).height() / 5;
		var windowScrolltop = $(window).scrollTop() + adjustH;
		for (var i = 0; i < contentsArr.length; i++) {
			if(contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
				navLink.removeClass('current');
				navLink.eq(i).addClass('current');
				i == contentsArr.length;
			}else if(windowScrolltop == adjustH){
				navLink.removeClass('current');
				navLink.eq(1).removeClass('current');              
            }
          
		};
	});
});